export default "__VITE_ASSET__B$EFGDZl__"